<template>
  <div>
  <h2>Dodaj produkt do magazynu</h2>
    <ItemForm :types="types" @submited="add($event)"/>
  </div>
</template>
<script>
import ItemForm from "@/components/storage/ItemForm";
import Messenger from "@/plugins/Messenger";
export default {
  components: {ItemForm},
  props: ['types'],
  data: () => ({
  }),
  methods:{
    add(form){

      if(!form.valid){
        Messenger.emitError("Popraw błedne pola")
        return
      }

      let postData = {
        'name' : form.name,
        'description' : form.description,
        'quantity' : form.quantity,
        'storage_type_id' : form.type.id
      }

      this.$http.post('storage', postData).then(()=>{
        Messenger.emitSuccess("Dodano produkt")
        this.$emit("created",true)
        this.$router.push('/storage')
      }).catch(()=>{
        Messenger.emitError("Nie można dodać produktu produktu")
      })
    }
  }
}
</script>